exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.xs-plugin-pullup-container {\r\n  text-align: center;\n}\r\n", "", {"version":3,"sources":["D:/git/qrt_m/node_modules/vux/src/components/scroller/index.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.xs-plugin-pullup-container {\r\n  text-align: center;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7769fa5b","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vux/src/components/scroller/index.vue
// module id = qLbN
// module chunks = 0